// Angular
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Afidium
import { CostComponent } from './cost.component';
import { QuotationResolve } from 'app_quotation/shared/services/quotation-resolve/quotation.resolve';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: ':id',
                redirectTo: `:id/cost/included`,
                pathMatch: 'full',
            },
            {
                path: `:id/cost`,
                redirectTo: `:id/cost/included`,
                pathMatch: 'full',
            },
            {
                path: `:id/cost/:subPage`,
                component: CostComponent,
                resolve: {
                    quotation: QuotationResolve
                }
            },
        ]),
    ],
    exports: [
        RouterModule,
    ],
})
export class CostRouting {
}